import { useContext } from 'react';
import { AddressDetails, Modal } from '@components';
import { ModalContext } from '@context';

import styles from './../modals.module.scss';

export const AddressModal = () => {
	const { showAddressModal, setShowAddressModal } = useContext(ModalContext);

	return (
		<Modal
			customModalStyle={styles['modal-address']}
			open={showAddressModal}
			closeable
			handleClose={() => setShowAddressModal(false)}
		>
			<AddressDetails />
		</Modal>
	);
};
